import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ListOvertime.config";
import {useAppDispatch, useAppSelector} from "../../../../../redux/hooks";
import {
  getPhongBanAPI,
  searchLamThem,
} from "../../../../../redux/reducer/employee";
import {ColumnProps} from "../../../../../types/models";
import Notification from "../../../../../components/common/notification/notification";
import {
  Button,
  Col,
  InputNumber,
  Popover,
  Input,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  Search,
} from "../../../../../components/common";
import Icons from "../../../../../assets/icons";
import {ExcelSVG, SaveWhiteIconSVG} from "../../../../../assets";
import {employeeService} from "api";
import axiosClient from "../../../../../api/axiosClient";
import { generateFileName, saveTableOptions, isApproveRecord } from "../../../../../helper/common";

import "./ListOvertime.scss";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { setButtonsHeader } from "redux/reducer/common";
import usePermission from "hooks/usePermission";
import ExpandSearchHCNS from "components/common/ExpandSearch/ExpandSearchHCNS";
const ListOvertime = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = currentDate.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    nam: currentYear,
    thang: currentMonth,
  });
  const { isNhanVien, isQuanLy, isGiamDoc } = usePermission();
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState<any>(
    allColumns.filter(e => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector(state => state.employeesReducer);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onClickSearch = async () => {
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({...params, ...searchFields, page: 1}); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  useEffect(() => {
    expandRef?.current.setFieldValue("nam", currentYear);
    expandRef?.current.setFieldValue("thang", currentMonth);
  }, []);
  const getList = async () => {
    setLoading(true);
    await dispatch(searchLamThem(params));
    setLoading(false);
  };

  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  useEffect(() => {
    getList();
  }, [params]);
  useEffect(() => {
    setData(
      employees.LamThemList.map(list => ({
        ...list,
        key: list.id,
      }))
    );
  }, [employees.LamThemList]);

  useEffect(() => {
    setColumns(
      allColumns
        .map(col => {
          if (!col.editable) {
            if (col.dataIndex === "index") {
              return {
                title: "STT",
                key: "index",
                show: true,
                dataIndex: "index",
                render(_, __, index) {
                  return <>{index + 1 + (params.page - 1) * params.limit}</>;
                },
                disabledCheck: true,
                fixed: "left",
                width: 50,
                align: "center",
                isResizable: true,
              };
            } else {
              return col;
            }
          }
          return {
            ...col,
            onCell: (record: any) => ({
              record,
              editable: true,
              dataIndex: col.dataIndex,
              title: col.title,
              handleSave,
            }),
          };
        })
        .filter(e => e.show == true)
    );
  }, [data]);
  const setShowColumnsList = showColumns => {
    saveTableOptions(
      "RECEIVED_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({...params, page: currentPage, limit: pageSize});
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({...paramss, ...searchFields});
    handleExportExcel(params);
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const handleExportExcel = async params => {
    const url = "hanhchinhnhansu/cham-cong-gio-lam-them/export-excel";
    const baseName = "danh-sach-lam-them-gio";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user

      Notification("error", "Error exporting Excel");
    }
  };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];

      const formData = new FormData();
      formData.append("files", excel);
      try {
        const response = await employeeService.uploadChamCong(formData);
        if (response.status == 200) {
        }
        Notification("success", "Tải lên file excel thành công");
      } catch (err) {
        Notification("error", "Lỗi khi tải lên file excel");
      }
    }
  };
  // const handleClick = () => {
  //   if (fileInputRef.current) {
  //     fileInputRef.current.click();
  //   }
  // };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const datas = data.map(rowData => {
        let abc: any = {};
        let keyName = "";
        let value = "";
        for (const key in rowData) {
          if (key.startsWith("day")) {
            keyName = key;
            value =
              rowData[key] === "TRUE" || rowData[key] === "FALSE"
                ? "0"
                : rowData[key];
            abc[key] = value;
          }
        }
        return {
          ...rowData,
          ...abc,
          key: rowData.id,
        };
      });
      const res = await employeeService.updateLamThem(datas);
      getList();
      Notification("success", "Cập nhập thành công ");
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
    }
    //onClickSearch();
  };
  useEffect(() => {
    dispatch(
      getPhongBanAPI({
        page: 1,
        limit: 100,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "phong");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find(field => field.name === tenPhongBan)) {
      inputFieldsInit.find(field => field.name === tenPhongBan).options =
        list?.map(item => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };

  const onKeyDown = e => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  const nam = params.nam;
  const thang = params.thang;
  const filteredColumns = allColumns.filter(e => e.dataIndex === "nam");
  filteredColumns.forEach(column => {
    column.title = "Tháng " + thang + " năm " + nam;
  });
  // useEffect(() => {
  //   const res = allColumns.map((e) => {
  //     if (e.dataIndex === "nam") {
  //       for (let i = 0; i < e.children.length; i++) {
  //         if (thang === 10) {
  //           e.children[10].children.find((e) => e.show === true).show = false;
  //         }
  //       }

  //     }
  //   });
  // }, []);
  useLayoutEffect(() => {
    const resetColumns = () => {
      setColumns([...allColumns.filter(e => e.show == true)]);
    };

    resetColumns();
  }, [thang]);
  function getAllDatesInMonth(year, month) {
    const startDate = new Date(year, month - 2, 21); // month is 0-indexed
    const endDate = new Date(year, month - 1, 20);
    const dates = [];
    while (startDate <= endDate) {
      dates.push(new Date(startDate)); // clone the date object
      startDate.setDate(startDate.getDate() + 1);
    }

    return dates;
  }

  // khi tháng này thay đổi thì component sẽ đc render lại -> nó sẽ kiểm tra điều kiện trong useEffec này
  useEffect(() => {
    // Lấy ngày từ tháng trc tới tháng sau
    const datesInFebruary2023 = getAllDatesInMonth(nam, thang);
    const dateOfMonth = [];
    datesInFebruary2023.map(e => {
      //Check ngày trong tuần
      const dayOfWeek = e.getDay();
      dateOfMonth.push({
        title: e.getDate(),
        width: 65,
        align: "center",
        className: "white",

        children: [
          {
            title: () => {
              switch (dayOfWeek) {
                case 0:
                  return "CN";
                case 1:
                  return "T2";
                case 2:
                  return "T3";
                case 3:
                  return "T4";
                case 4:
                  return "T5";
                case 5:
                  return "T6";
                case 6:
                  return "T7";
              }
            },
            key: `day${e.getDate()}`,
            show: true,
            dataIndex: `day${e.getDate()}`,
            width: 65,
            align: "center",
            className:
              dayOfWeek === 0 || dayOfWeek === 6 ? "green blue" : "white",
          },
        ],
      });
    });
    if (dateOfMonth) {
      columns.find(item => item.dataIndex === "nam").children = dateOfMonth;
    }
  }, [thang, nam]);

  const today = currentDate.getDate().toString();
  columns.map(record => {
    if (record.dataIndex == "soGioLamViecChuan") {
      record.render = (value, record, index) => (
        <InputNumber
          style={{width: "100%"}}
          value={value}
          onChange={value => {
            const newData = [...data];
            newData[index]["soGioLamViecChuan"] = value;
            setData(newData);
          }}
          disabled={isApproveRecord(record)}
        />
      );
    } else if (record.dataIndex == "nam") {
      if (record.children) {
        for (let i = 0; i < record.children.length; i++) {
          const title = record.children[i].title;

          const dataIndex = record.children[i].children.find(
            item => item.dataIndex
          );
          if (dataIndex) {
            if (dataIndex) {
              switch (dataIndex.dataIndex) {
                case "day21":
                case "day22":
                case "day23":
                case "day24":
                case "day25":
                case "day26":
                case "day27":
                case "day28":
                case "day29":
                case "day30":
                case "day31":
                case "day1":
                case "day2":
                case "day3":
                case "day4":
                case "day5":
                case "day6":
                case "day7":
                case "day8":
                case "day9":
                case "day10":
                case "day11":
                case "day12":
                case "day13":
                case "day14":
                case "day15":
                case "day16":
                case "day17":
                case "day18":
                case "day19":
                case "day20":
                  dataIndex.render = (value, record, index) => (
                    <InputNumber
                      style={{
                        width: "100%",
                        backgroundColor:
                          value === "TRUE"
                            ? "red"
                            : value === "x"
                            ? "#f1f1f153"
                            : value === "FALSE"
                            ? "yellow"
                            : "white",
                        borderRadius: "5px",
                      }}
                      value={
                        value === "TRUE" ? "0" : value === "FALSE" ? "0" : value
                      }
                      onChange={value => {
                        console.log(value);
                        const newData = [...data];
                        newData[index][dataIndex.dataIndex] = value;
                        setData(newData);
                      }}
                      disabled={value === "x" || isApproveRecord(record)}
                    />
                  );
              }
            }
          }
        }
      }
    } else if (record.dataIndex === "soGioLamThemTinhLuong") {
      record.render = (value, record, index) => (
        <InputNumber
          style={{width: "100%"}}
          value={value}
          onChange={value => {
            const newData = [...data];
            newData[index]["soGioLamThemTinhLuong"] = value;
            setData(newData);
          }}
          disabled={isApproveRecord(record)}
        />
      );
    }
  });

  const squareStyle = {
    display: "inline-block",
    width: "16px",
    height: "16px",
    borderRadius: "2px",
    marginTop: "8px",
  };
  const textStyle = {
    marginRight: "15px",
    fontFamily: "Segoe UI",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "20px",
    fontSize: "14px",
  };
  const spanSymbol = {
    color: "#00B335",
    fontSize: "14px",
    fontFamily: "Segoe UI",
    fontWeight: "600",
    lineHeight: "20px",
    marginLeft: "4px",
  };
  const frame = {
    marginLeft: "2px",
    marginBottom: "-4px",
  };
  const onKeyDownSearch = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    // const numberOfDaysInMonth = new Date(nam, thang, 0).getDate();
    // const dataIndex =  showColumns.filter(element => element.dataIndex === "nam")
    // for (let i = 0; i < dataIndex.children.length ; i++) {
    //
    // }
    setColumns(showColumns);
  };
  return (
    <div className="recruitment-list" tabIndex={0}>
      <div className="recruitment-container">
        <div className="container" onKeyDown={onKeyDownSearch}>
          <ExpandSearchHCNS
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container" onKeyDown={onKeyDown}>
          <Space style={{width: "100%"}} direction="vertical">
            {/*<Typography.Text strong>Danh sách nhân viên</Typography.Text>*/}
            {/*<Divider type="horizontal" style={{ margin: "0" }} />*/}

            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col span={15}>
                <Row>
                  <div style={{marginRight: 12}}>
                    <Popover
                      trigger="click"
                      placement="topLeft"
                      content={
                        <ColumnPopoverDisplay
                          setShowColumns={setShowColumns}
                          columns={columns}
                          width={"400px"}
                        ></ColumnPopoverDisplay>
                      }
                    >
                      <Button
                        icon={<Icons.bars rev={0} />}
                        className="btn-sub"
                        type="ghost"
                      >
                        Cột hiển thị
                      </Button>
                    </Popover>
                  </div>
                  <div>
                    <span
                      style={{...squareStyle, backgroundColor: "#69FFD4"}}
                    ></span>
                    <span style={textStyle}> Cuối tuần</span>
                  </div>
                </Row>
              </Col>
              <Col>
                <Space style={{width: "100%"}}>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  {/* <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleUpload}
                  ref={fileInputRef}
                /> */}
                  {/* <Button
                  icon={<Icons.upload rev={0} />}
                  className="btn-sub"
                  type="ghost"
                  onClick={handleClick}
                  style={{
                    width: "100px",
                  }}
                >
                  Import
                </Button> */}
                  <Button
                    className="custom-btn"
                    type="primary"
                    htmlType="submit"
                    onClick={handleSubmit}
                    icon={<SaveWhiteIconSVG />}
                    disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                  >
                    Lưu lại
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.LamThemTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                rowKey={record => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{x: 3000}}
              />
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListOvertime;
